module.exports = __webpack_public_path__ + "img/9788952764614.34a4ec96.jpg";